import { Gift, Users } from 'lucide-react';

export type PerkItem = {
  id: string;
  name: string;
  provider: string;
  providerBlurb?: string;
  description: string;
  eligibility?: string;
  valueLabel?: string;
};

export const perksPool: PerkItem[] = [
  {
    id: 'efficient-cloud-audit',
    name: 'Free 30-minute cloud-cost optimization consultation',
    provider: 'Efficient Cloud',
    providerBlurb: 'A boutique FinOps consultancy that helps engineering teams cut their AWS, GCP, and Azure bills.',
    description: 'A senior cloud-cost engineer will audit your cloud bill and walk you through quick wins to cut spend. No strings, no upsell.',
    eligibility: 'Open to all members',
    valueLabel: 'Worth $500+',
  },
  {
    id: 'northstar-coaching',
    name: 'One complimentary executive coaching session',
    provider: 'Northstar Coaching',
    providerBlurb: 'ICF-certified coaches working with founders and senior operators.',
    description: 'A 60-minute 1:1 session with a vetted executive coach to work through a leadership challenge you are facing right now.',
    eligibility: 'First 25 to claim each month',
    valueLabel: 'Worth $400',
  },
  {
    id: 'wellfound-notebook',
    name: 'Hand-bound leather notebook, shipped to your door',
    provider: 'Wellfound Stationery',
    providerBlurb: 'A small-batch stationer in Maine making notebooks for the long haul.',
    description: 'A signature A5 notebook with 240 pages of Tomoe River paper. Pick your cover color at checkout.',
    eligibility: 'Open to all members',
    valueLabel: 'Worth $85',
  },
];

export function perkCardTitle(_item: PerkItem): string {
  return 'Would you like to claim this perk?';
}

export function PerkCard({ item }: { item: PerkItem }): JSX.Element {
  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm overflow-hidden">
      <div className="p-6 space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
            <Gift size={16} className="text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[12px] uppercase tracking-wider text-muted-foreground font-semibold">
              {item.provider}
            </p>
            <p className="font-semibold text-[17px] leading-snug text-foreground mt-1">
              {item.name}
            </p>
            {item.valueLabel ? (
              <span className="inline-block mt-2 bg-primary/10 text-primary rounded-full px-2 py-0.5 text-[11px] font-medium">
                {item.valueLabel}
              </span>
            ) : null}
          </div>
        </div>

        {item.providerBlurb ? (
          <div className="border-l-2 border-primary/40 pl-4 py-1">
            <p className="text-[10px] uppercase tracking-wider text-primary/80 font-semibold mb-1.5">
              About {item.provider}
            </p>
            <p className="text-[13px] text-foreground/80 leading-relaxed">
              {item.providerBlurb}
            </p>
          </div>
        ) : null}

        <p className="text-[15px] text-foreground/90 leading-relaxed">
          {item.description}
        </p>

        {item.eligibility ? (
          <p className="flex items-center gap-1.5 text-[12px] text-muted-foreground">
            <Users size={12} />
            {item.eligibility}
          </p>
        ) : null}
      </div>
    </div>
  );
}
